import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyB6kj6-HfpQhamFux1aLKdTGHC6Cwtcwh8",
  authDomain: "click-saver.firebaseapp.com",
  projectId: "click-saver",
  storageBucket: "click-saver.firebasestorage.app",
  messagingSenderId: "2970233706",
  appId: "1:2970233706:web:9e6c211090da0674201313",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
